import { IExtractAddDialogProp } from "./ExtractAddDialog.view";
import ExtractAdd from "./ExtractAddDialog.logic";
import { IExtractAddProp } from "./ExtractAdd.logic";
import { Slice as ExtractAddSlice } from "./redux/Slice";

export { ExtractAddSlice };

export {
  IExtractAddProp,
  IExtractAddDialogProp,
};

export default ExtractAdd;
